export default __webpack_public_path__ + "static/media/mobile-bg.f6fedd45.png";